var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "edit"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.72615 5.65978L9.3726 5.30623L9.01905 5.65978L2.97905 11.6998L2.8326 11.8462V12.0533V12.6667V13.1667H3.3326H3.94593H4.15304L4.29949 13.0202L10.3395 6.98022L10.693 6.62667L10.3395 6.27311L9.72615 5.65978ZM13.4524 4.33978L12.5859 5.20623L10.793 3.41333L11.6595 2.54689C11.6889 2.51744 11.7336 2.5 11.7726 2.5C11.8249 2.5 11.8607 2.51522 11.8924 2.54689L13.4524 4.10689C13.5171 4.17162 13.5171 4.27504 13.4524 4.33978ZM2.49927 11.7071L9.3726 4.83377L11.1655 6.62667L4.29216 13.5H2.49927V11.7071Z",
    fill: "#787E7D",
    stroke: "#787E7D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.3c0e484a7e3498cf9c0e746f288fda74.svg";
export { ForwardRef as ReactComponent };